// TODO: Update type to be from the purchase-api once added
import type { PollUserActionResponse } from "@b2bportal/lloyds-user-action-cart-api";
import { FulfillResponseEnum, type CipherText } from "@b2bportal/purchase-api";
import { trackCheckoutEvent } from "@checkout/tracking/sink";
import { axiosInstance } from "@hopper-b2b/api";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { getPriceQuoteCipherText } from "../../CartQuote/selectors";
import type { CartContext } from "../../context";
import { getFulfillCipherText } from "../selectors";

// TODO: Use purchaseApi once endpoint is available there
const pollUserActionPath = "/api/v1/purchase/pollUserAction";

export interface PollUserActionRequest {
  quoteToken: CipherText;
  fulfillToken: CipherText;
}

export const pollUserActionService = async (
  context: CartContext,
  _event: unknown
): Promise<PollUserActionResponse> => {
  try {
    const quoteCipherText = getPriceQuoteCipherText({ context });
    const fulFillCipherText = getFulfillCipherText({ context });

    let poll = true;

    while (poll) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const res = await axiosInstance.put(pollUserActionPath, {
        quoteToken: quoteCipherText,
        fulfillToken: fulFillCipherText,
      });
      if (res.data.Response === FulfillResponseEnum.Success) {
        if (res.data.value.PollUserActionResponse === "Pending") {
          continue;
        }
        poll = false;
        return res.data.value;
      } else {
        throw res.data;
      }
    }
  } catch (e) {
    trackCheckoutEvent({
      eventName: NETWORK_CALL_FAILED,
      properties: {
        url: window.location.pathname,
      },
    });
    throw e;
  }
};
